<template>
  <div class="fillSpace">
    <div class="appcontainer" id="appcontainer">
      <div @click="slideCarouselRight" v-show="rightActive" class="slideRight slideButton"></div>
      <div @click="slideCarouselLeft" v-show="leftActive" class="slideLeft slideButton"></div>

      <Carousel ref="carousel" :scale="scale" :widthApp="widthApp" id="target" @updateCarousel="updateCarousel" />
    </div>
    <AppMenu>
      <template v-slot:topleft>
        <div class="container-title">
          <RoundButton
            class="bordered back"
            href="/"
            :width="currentScreenWidth > 1024 ? 35 : 25"
            image="ic-arrow-back.svg"
          />
          <h2 class="titleDiscover">{{ getWebcontrol('Produits-Titre-DecouvrirLesVerresEssilor') }}</h2>
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../assets/logo.png" />
      </template>

      <template v-slot:bottomcenter>
        <input
          type="range"
          class="slider"
          min="0"
          step="1"
          :max="$refs.carousel.maxScroll"
          v-model="$refs.carousel.scrollPosition"
        />
      </template>
    </AppMenu>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
import RoundButton from '@Components/Menus/RoundButton.vue';
import Carousel from '@Components/Carousel.vue';

export default {
  components: {
    RoundButton,
    Carousel,
    AppMenu,
  },
  data() {
    return {
      leftActive: false,
      rightActive: true,
      scale: 1,
      widthApp: null,
      threshold: 5,
    };
  },
  computed: {
    currentScreenWidth() {
      return window.outerWidth;
    },
    //return fraction to which the carousel need to be shrinked
    scaleValue() {
      var clientHeight = document.getElementById('appcontainer').clientHeight;
      if (clientHeight - 128 < 560) {
        return (clientHeight - 128) / 560;
      }
      return 1;
    },
  },
  mounted() {
    this.$gtag.pageview({
      page_title: 'Découvrir les verres',
      page_path: '/Découvrir les verres',
      page_location: window.location.href,
    });

    window.localStorage.removeItem('crizal_left');
    window.localStorage.removeItem('crizal_right');
    //create and inject a style element to apply css
    var style = document.createElement('style');
    document.head.appendChild(style);

    //get the width and height of the carousel container
    this.widthApp = document.getElementById('appcontainer').clientWidth;
    var clientHeight = document.getElementById('appcontainer').clientHeight;

    //if the app heigth get to small, the scall of the carousel get scall down
    if (clientHeight - 128 < 560) {
      this.scale = this.scaleValue;
      var margeTop = -(560 - 560 * this.scale) / 2 + 64;
      style.sheet.insertRule('#target {top: ' + margeTop.toString(10) + 'px');
      style.sheet.insertRule('#target {transform: scale(' + this.scale.toString(10) + ')}');
    } else {
      style.sheet.insertRule('#target {top: 64px');
    }
  },
  methods: {
    //update the left and right button
    updateCarousel() {
      if (this.$refs.carousel.scrollPosition >= this.$refs.carousel.maxScroll - this.threshold) {
        this.rightActive = false;
      } else {
        this.rightActive = true;
      }
      if (this.$refs.carousel.scrollPosition <= 0) {
        this.leftActive = false;
      } else {
        this.leftActive = true;
      }
    },
    //called when the right carousel button is pushed in order to move and update the button
    slideCarouselRight() {
      this.$refs.carousel.slideCarouselButton(1);
      if (this.$refs.carousel.scrollPosition >= this.$refs.carousel.maxScroll - this.threshold) {
        this.rightActive = false;
      }
      this.leftActive = true;
    },
    //called when the left carousel button is pushed in order to move and update the button
    slideCarouselLeft() {
      this.$refs.carousel.slideCarouselButton(-1);
      if (this.$refs.carousel.scrollPosition <= 0) {
        this.leftActive = false;
      }
      this.rightActive = true;
    },
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
  },
};
</script>

<style scoped>
.scale {
  position: relative;
}

.slideButton {
  position: absolute;
  z-index: 13;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  top: 50%;
  background-color: white;
  border: 1px rgba(26, 26, 26, 0.15) solid;
  font-size: 20px;
  padding: 9px 0 0 0;
}

.slideLeft:after {
  font-family: 'Palatino Linotype', 'Book Antiqua';
  content: '<';
}

.slideRight {
  right: 0px;
}

.slideRight:after {
  font-family: 'Palatino Linotype', 'Book Antiqua';
  content: '>';
}

.slideLeft {
  left: 0px;
}

.appcontainer {
  background-color: #e6edf5; /* rgba(0, 0, 0, 0.05); */
  position: absolute;
  top: 10vh;
  bottom: 10vh;
  left: 7vw;
  right: 7vw;
  justify-content: center;
  align-items: center;
  transform: scale(1);
}

.fillSpace {
  width: 100%;
  height: 100%;
}

.titleDiscover {
  align-self: center;
  padding-left: 20px;
}

.bottomRight {
  position: absolute;
  z-index: 1002;
  bottom: -15px;
  right: 25px;
  width: 160px;
  height: 65px;
  top: 97%;
}

.container-title {
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.back:hover {
  border: 1px solid black;
}

input[type='range'] {
  -webkit-appearance: none;
  width: 135px;
  margin: 0.05px 0;
}
input[type='range']:focus {
  outline: none;
}
input[type='range']::-webkit-slider-runnable-track {
  width: 135px;
  height: 3px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  background: #b4b4b6;
  border-radius: 1.3px;
  border: 0px solid rgba(1, 1, 1, 0);
}
input[type='range']::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  border: 0px solid rgba(0, 0, 0, 0);
  height: 3px;
  width: 50px;
  border-radius: 0px;
  background: #292929;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -0.05px;
}
input[type='range']:focus::-webkit-slider-runnable-track {
  background: #e3e3e3;
}
input[type='range']::-moz-range-track {
  width: 135px;
  height: 3px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  background: #e3e3e3;
  border-radius: 1.3px;
  border: 0px solid rgba(1, 1, 1, 0);
}
input[type='range']::-moz-range-thumb {
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  border: 0px solid rgba(0, 0, 0, 0);
  height: 3px;
  width: 50px;
  border-radius: 0px;
  background: #292929;
  cursor: pointer;
}
input[type='range']::-ms-track {
  width: 135px;
  height: 3px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type='range']::-ms-fill-lower {
  background: #e3e3e3;
  border: 0px solid rgba(1, 1, 1, 0);
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
}
input[type='range']::-ms-fill-upper {
  background: #e3e3e3;
  border: 0px solid rgba(1, 1, 1, 0);
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
}
.sliderContainer {
  bottom: -35px;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  z-index: 1010;
}

input[type='range']:focus::-ms-fill-lower {
  background: #e3e3e3;
}
input[type='range']:focus::-ms-fill-upper {
  background: #e3e3e3;
}

input[type='range']::after {
  content: '';
  display: inline-block;
  position: absolute;

  width: 135px;
  border-style: solid;
  top: 0;
  border-width: 1vw;
  border-color: transparent;
  cursor: pointer;
}
</style>
